import PropTypes from 'prop-types';
import React from 'react';
import ReactTooltip from 'react-tooltip';
import { Button } from '@ontruck/orc';
import moment from 'moment';

const LogCarrierNotes = ({ className, log, id }) => {
  const t = {
    today_time: '[Today] HH:mm',
    yesterday_time: '[Yesterday] HH:mm',
    full_datetime: 'dddd DD MMM YYYY HH:mm',
  };

  const LogDate = (date) => {
    if (!date) {
      return '';
    }

    const formatDate = moment(date);
    const today = moment();

    if (formatDate.isSame(today, 'day')) {
      return formatDate.format(t.today_time);
    }

    if (formatDate.isSame(today.subtract(1, 'days'), 'day')) {
      return formatDate.format(t.yesterday_time);
    }

    return formatDate.format(t.full_datetime);
  };

  const renderLogItems = () =>
    log.map((item, index) => {
      return (
        <li key={`log-entry-${index}-${id}`} className="log-carrier-notes__item">
          <p className="log-carrier-notes__content log-carrier-notes__title">{item.title}</p>
          {item.text && (
            <p className="log-carrier-notes__content log-carrier-notes__text">{`"${item.text}"`}</p>
          )}
          <p className="log-carrier-notes__content">
            <span className="log-carrier-notes__subtitle">{`${
              item.created_by ? `${item.created_by} - ` : ''
            }${LogDate(item.created_at)}`}</span>
          </p>
        </li>
      );
    });

  if (!log || log.length < 1) return null;

  return (
    <div className={className} data-testid="logCarrierNotes">
      <div className="log-carrier-notes">
        <Button
          className="log-carrier-notes__button"
          icon="comments"
          iconPosition="left"
          nude
          onClick={(e) => {
            e.stopPropagation();
          }}
          data-tip
          data-event="click focus"
          data-for={`driver-log-${id}`}
          data-testid="logCarrierNotesOpener"
        />
        <ReactTooltip
          className="log-carrier-notes__tooltip-container"
          id={`driver-log-${id}`}
          type="light"
          effect="solid"
          place="bottom"
          clickable
          globalEventOff="click"
          isCapture
        >
          <div className="log-carrier-notes__tooltip" data-testid="logCarrierNotesContainer">
            <ul className="log-carrier-notes__list">{renderLogItems()}</ul>
          </div>
        </ReactTooltip>
      </div>
    </div>
  );
};

LogCarrierNotes.defaultProps = {
  className: '',
  log: [],
};

LogCarrierNotes.propTypes = {
  className: PropTypes.string,
  id: PropTypes.number.isRequired,
  log: PropTypes.array,
};

export default LogCarrierNotes;
